import { Target, Activity, LineChart, Map, Scale, GraduationCap, BarChart3 } from "lucide-react";

// Canonical 7 primary services shown on /services and /pricing.
// Prices are quoted ranges (see QuoteModal) — the $250 paid consultation
// (see /book-consultation) remains the only upfront Stripe checkout item.
export const SERVICES = [
  {
    id: "program-evaluation",
    icon: Target,
    title: "Program Evaluation",
    subtitle: "Process, Outcome & Impact",
    desc: "Full evaluation cycles for public health programs — from formative design through impact reporting for funders and boards.",
    bullets: ["Evaluability assessments", "Mixed-methods design", "Funder-aligned reporting"],
    priceRange: "$8,000 – $45,000",
  },
  {
    id: "evaluation-plan-development",
    icon: Activity,
    title: "Evaluation Plan Development",
    subtitle: "Logic Models & Theory of Change",
    desc: "Facilitated logic model and theory-of-change frameworks your team and funders can rally around.",
    bullets: ["Stakeholder workshops", "Logic model deliverables", "Driver diagrams"],
    priceRange: "$4,000 – $12,000",
  },
  {
    id: "data-epi-analysis",
    icon: BarChart3,
    title: "Data Collection & Epidemiological Analysis",
    subtitle: "Surveys, Surveillance & Trend Detection",
    desc: "Primary and secondary data collection, epi analysis, and trend detection calibrated to your population and indicators.",
    bullets: ["Survey instrument design", "R / Python analysis pipelines", "Trend & disparity detection"],
    priceRange: "$6,000 – $25,000",
  },
  {
    id: "chna",
    icon: Map,
    title: "Community Health Needs Assessments",
    subtitle: "CHNAs",
    desc: "ZIP-code health profiles, key informant interviews, and stakeholder-informed prioritization.",
    bullets: ["Secondary data synthesis", "Key informant interviews", "Priority frameworks"],
    priceRange: "$12,000 – $35,000",
  },
  {
    id: "health-equity-evaluation",
    icon: Scale,
    title: "Health Equity Evaluation",
    subtitle: "Disparities, SDOH & Access",
    desc: "Disparities analysis, SDOH integration, ACEs frameworks, and access measurement.",
    bullets: ["Disaggregated reporting", "SDOH indicators", "Equity-centered methodology"],
    priceRange: "$8,000 – $28,000",
  },
  {
    id: "grant-required-evaluation-plans",
    icon: GraduationCap,
    title: "Grant-Required Evaluation Plans",
    subtitle: "Funder-Ready Submissions",
    desc: "Funder-ready evaluation plans for federal and state grant submissions.",
    bullets: ["CDC / HRSA / SAMHSA standards", "Performance measures", "Reviewer-tested language"],
    priceRange: "$4,000 – $15,000",
  },
  {
    id: "dashboard-reporting",
    icon: LineChart,
    title: "Dashboard Creation & Reporting",
    subtitle: "Live KPI & Impact Dashboards",
    desc: "Interactive dashboards and recurring reporting built for non-technical audiences and boards.",
    bullets: ["Tableau & Power BI builds", "Automated recurring reports", "Board-ready visualizations"],
    priceRange: "$3,500 – $12,000",
  },
];
